import { Link } from "react-router-dom";

export default function Person({ person }) {
  return (
    <>
      <li>
        Nome: {person.firstName} {person.lastName}
      </li>
      <ul>
        <li>Idade: {person.age}</li>
        <li>Sexo: {person.gendre === "M" ? "Masculino" : "Feminino"}</li>
        <li>Endereço: {person.address}</li>
        <li>
          <b>Responsável: </b>
          <Link to="/consultarresponsaveis">{person.guardianName}</Link>
        </li>
        <hr></hr>
      </ul>
    </>
  );
}
